import { supabase } from './supabase.js';
const redirect = () => location.origin + '/';
const must = r => { if (r.error) throw r.error; return r.data; };
export const auth = {
  session: async () => must(await supabase.auth.getSession()).session,
  signIn: async (email, password) => must(await supabase.auth.signInWithPassword({ email, password })),
  signUp: async (email, password, full_name) => must(await supabase.auth.signUp({ email, password, options: { data: { full_name }, emailRedirectTo: redirect() } })),
  forgot: async email => must(await supabase.auth.resetPasswordForEmail(email, { redirectTo: redirect() })),
  updatePassword: async password => must(await supabase.auth.updateUser({ password })),
  signOut: async () => must(await supabase.auth.signOut({ scope: 'local' })),
  onChange: fn => supabase.auth.onAuthStateChange(fn),
};
